module.exports = __webpack_public_path__ + "img/launch.7e0640fb.svg";